import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DashboardFilledSvg from "@ant-design/icons-svg/es/asn/DashboardFilled";
import AntdIcon from '../components/AntdIcon';
var DashboardFilled = function DashboardFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: DashboardFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(DashboardFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'DashboardFilled';
}
export default RefIcon;